export function Wordmark({ className = "", style = {} }) {
  return (
    <span className={`wordmark ${className}`} style={style} data-testid="wordmark">
      Practical <em>AI</em> for Everyday Life
    </span>
  );
}
